/// <amd-module name="Test/AttachmentsView/Source/AttachmentsViewSource" />
import * as TestManagementService from "Test/Client/TestManagementServices";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { IVssPageContext } from "VSS/Platform/Context";

export class AttachmentsViewSource {

    public getAttachments(pageContext: IVssPageContext, testRunId: number, testResultId: number, subResultId: number): Promise<TCMContracts.TestAttachment[]> {
        let tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        
        if (testResultId > 0) {
            if (subResultId > 0) {
                return tcmService.getTestSubResultAttachments(testRunId, testResultId, subResultId);
            } else {
                return tcmService.getTestResultAttachments(testRunId, testResultId);
            }
        } else {
            return tcmService.getTestRunAttachments(testRunId);
        }
    }

    public loadAttachmentContent(pageContext: IVssPageContext, attachmentId: number, testRunId: number, testResultId: number, subResultId: number): Promise<ArrayBuffer> {
        let tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        
        if (testResultId > 0) {
            if (subResultId > 0) {
                return tcmService.getTestSubResultAttachmentContent(testRunId, testResultId, attachmentId, subResultId);
            } else {
                return tcmService.getTestResultAttachmentContent(testRunId, testResultId, attachmentId);
            }
        } else {
            return tcmService.getTestRunAttachmentContent(testRunId, attachmentId);
        }
    }
}
